import React from 'react'

const WorksItems = ({item}) => {
  return (
    <div className="work_card">
      {item.image ? (
        <img src={item.image} alt={item.title} className='work_img'/>
      ) : (
        <div className="work_icon-box">
          <i className={`${item.icon} work_icon`}></i>
        </div>
      )}
      <h3 className="work_title">{item.title}</h3>
      <p className="work_description">{item.description}</p>
      <ul className="work_tags">
        {item.tags.map((tag) => (
          <li className="work_tag" key={tag}>{tag}</li>
        ))}
      </ul>
      {item.link ? (
        <a href={item.link} className="work_button" target="_blank" rel="noreferrer">
          Demo <i className="bx bx-right-arrow-alt work_button-icon"></i>
        </a>
      ) : (
        <span className="work_private">
          <i className="bx bx-lock-alt"></i> Private · details on request
        </span>
      )}
    </div>
  )
}

export default WorksItems
